import { FormEvent, useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import { useAuth } from '../context/AuthContext';
import { request } from '../services/httpClient';

const SupportPage = () => {
  const { user } = useAuth();
  const [form, setForm] = useState({ message: '' });
  const [status, setStatus] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    if (!user) {
      setError('You must be signed in to contact support.');
      return;
    }
    setLoading(true);
    setStatus(null);
    setError(null);
    try {
      await request('/v2/support/contact.php', {
        method: 'POST',
        body: JSON.stringify({ message: form.message })
      });

      setStatus('Thanks for reaching out. Our support team will reply soon.');
      setForm({ message: '' });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to send support request');
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout title="Support">
      <div className="section">
        <div className="card hero-card">
          <span className="eyebrow">Support</span>
          <h3 style={{ margin: '0.4rem 0' }}>Need help with Gate.haus?</h3>
          <p style={{ color: 'var(--dark)', marginBottom: '0.5rem' }}>
            Send a message to our support team. Include as much detail as possible so we can respond quickly.
          </p>
          <p style={{ color: 'var(--gray)', margin: 0 }}>We aim to respond to all requests within 24 hours.</p>
        </div>
        <form className="card" onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <div className="input-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              rows={4}
              placeholder="e.g. I cannot sign into Gate.haus on my phone..."
              required
              value={form.message}
              onChange={handleChange}
            />
          </div>
          {status && (
            <p style={{ color: 'var(--success)' }} role="status">
              {status}
            </p>
          )}
          {error && (
            <p style={{ color: 'var(--danger)' }} role="alert">
              {error}
            </p>
          )}
          <button className="primary-button" type="submit" disabled={loading}>
            {loading ? 'Sending…' : 'Send request'}
          </button>
        </form>
      </div>
    </DashboardLayout>
  );
};

export default SupportPage;
